import React, { useRef } from "react";
import { createPortal } from "react-dom";
import useOutsideClick from "../Hooks/useOutsideClick";
import backgroundImage from "~/images/modal-background-image.png";
import { Close } from "@mui/icons-material";

const ConfirmDeleteModal = ({ closeModal, handleDelete, entityName, id_340b, tpaName }) => {
  const modalRef = useRef();
  useOutsideClick(modalRef, closeModal);

  function handleSubmit() {
    handleDelete();
    closeModal();
  }

  return createPortal(
    <div className="tpa-modal__background">
      <div className="tpa-modal__container" ref={modalRef}>
        <div className="tpa-modal__header">
          <div className="tpa-modal__header__img">
            <img src={backgroundImage} width={145} />
          </div>
          <div className="button button--sq-md button--transparent" onClick={closeModal}>
            <Close />
          </div>
        </div>
        <div className="tpa-modal__body gap--32">
          <div className="t--xl t--500">Revoke TPA Access?</div>

          <div>
            Please confirm that you want to revoke all access for <span className="t--500">{tpaName}</span> to{" "}
            <span className="t--500">{`${entityName} (${id_340b})`}</span>.
          </div>

          <div className="flex justify-content-end gap--16">
            <button className="button button--white" onClick={closeModal}>
              Cancel
            </button>
            <button className="button button--blue" onClick={handleSubmit}>
              Yes, Revoke Access
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmDeleteModal;
